module.exports = __webpack_public_path__ + "img/fenaju_logo.2da667dd.png";